import { useMatches } from 'react-router'

import type { RouteHandle } from '@/app/navigation'

/** Title of the deepest matched route that declares `handle.title` (see `router.tsx`). */
export function usePageTitle() {
  const matches = useMatches()

  for (let index = matches.length - 1; index >= 0; index--) {
    const handle = matches[index]?.handle as Partial<RouteHandle> | undefined
    if (handle?.title) return handle.title
  }
  return null
}
